import { useNavigate, useSearch } from '@tanstack/react-router';

const usePagination = (totalItems: number, paginatorKey: string) => {
    const navigate = useNavigate();
    const { page, page_size } = useSearch({});

    const pageSize =
        page_size ||
        parseInt(localStorage.getItem(paginatorKey + 'PageSize') || '50');

    const pageCount = Math.ceil(totalItems / pageSize);

    const setPage = (newPage: number) => {
        navigate({ search: prev => ({ ...prev, page: newPage }) });
    };

    const setPageSize = (value: number) => {
        localStorage.setItem(paginatorKey + 'PageSize', value.toString());
        navigate({ search: prev => ({ ...prev, page_size: value }) });
    };

    return {
        page,
        setPage,
        pageCount,
        pageSize,
        setPageSize,
    };
};

export default usePagination;
